var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { service, baseURL, squibTestEndpoint, base, localStorageAdapter } from '@/services/app.service';
// TODO this file should go away once all endpoints are separate
// import all services
import CategoryModel from '@/models/CategoryModel';
import ItemModel from '@/models/ItemModel';
import OptionModel from '@/models/OptionModel';
import OptionExceptionModel from '@/models/OptionExceptionModel';
import CustomerModel from '@/models/CustomerModel';
import LocationModel from '@/models/LocationModel';
import { ERROR_MSG } from '@/common/messages/error.msg';
import FranchisorModel from '@/models/FranchisorModel';
import customerService from '@/services/customer.service';
import * as moment from 'moment-timezone';
import { getParam } from '@/utils/helper.functions';
import { map, reduce, sortBy } from 'lodash';
import EventBus from '@EventBus';
var mockOloJSON = require('@/mocks/MockOlo.json');
var recentScripts = '1';
var USE_MOCK_DATA = location.search.indexOf('use_mocks') !== -1;
export function convertToModel(Model, dataArray, baseURL) {
    return map(dataArray, function (dataRaw) {
        var data = Object.assign({ baseURL: baseURL }, dataRaw);
        var obj = new Model(data);
        return obj;
    });
}
export function populateStores(response, callback) {
    var dataRoot = response.data.body;
    var customerData = dataRoot.customer || { customer: {}, id: {} };
    var menuData = dataRoot.menu;
    var franchisor = new FranchisorModel(dataRoot.franchisor);
    var customer = new CustomerModel(__assign({}, customerData.customer, { id: customerData.customer.base }));
    var customerLoyaltyOffers = (customer && customer.offers) ? customerData.customer.offers : null;
    var offers = customerService.convertAllCustomerOffers(customer, franchisor, customerLoyaltyOffers);
    var menu = null;
    if (menuData) {
        var items = convertToModel(ItemModel, menuData.items_map, response.baseURL);
        items = sortBy(items, function (item) {
            return item.outOfStock;
        });
        var options = convertToModel(OptionModel, menuData.options_map, response.baseURL);
        var optionExceptions = convertToModel(OptionExceptionModel, menuData.option_exception_map, response.baseURL);
        var categories = convertToModel(CategoryModel, menuData.categories, response.baseURL);
        var optionExceptionMapbyItem_1 = reduce(menuData.option_exception_map, function (obj, exception) {
            obj[exception[0]] = exception[1];
            return obj;
        }, {});
        // define items with exceptions
        items.forEach(function (item) {
            if (optionExceptionMapbyItem_1[item.id]) {
                item.hasExceptions = true;
            }
        });
        var menuId = menuData.menu_id;
        menu = {
            items: items,
            options: options,
            optionExceptions: optionExceptions,
            categories: categories,
            menuId: menuId
        };
    }
    var location = dataRoot.location;
    if (dataRoot.location) {
        location = new LocationModel(dataRoot.location);
        moment.tz.setDefault(location.timeZone);
    }
    var apiKey = null;
    if (franchisor) {
        apiKey = franchisor.getGoogleMapsAPIKey();
    }
    if (location) {
        apiKey = location.getGoogleMapsAPIKey();
    }
    var recentOrders = customerData.recent_scripts;
    var activeOrder = customerData.active_order;
    callback({
        menu: menu,
        customer: customer,
        offers: offers,
        recentOrders: recentOrders,
        location: location,
        activeOrder: activeOrder,
        franchisor: franchisor,
        apiKey: apiKey
    });
}
// TODO for now all service needs to get called
var allService = {
    load: function (callback, lb) {
        if (lb === void 0) { lb = null; }
        if (USE_MOCK_DATA) {
            var data = { data: mockOloJSON };
            var loadResponse = Object.assign({ baseURL: baseURL }, data);
            return populateStores(loadResponse, callback);
        }
        var storedCustomerBase = localStorageAdapter.getCustomerBase();
        var cb = (storedCustomerBase) ? storedCustomerBase : '';
        // if passed in location base, use that location
        var locationBase = lb || base;
        var debug = getParam('debug');
        var loadAll = "/admin/" + squibTestEndpoint + "?b=" + locationBase + "&cb=" + cb + "&rs=" + recentScripts + "&debug=" + debug;
        return service
            .get(loadAll)
            .then(function (response) {
            var data = response.data;
            var body = data.body;
            if (response.data.message === ERROR_MSG.APP.ONLINE_ORDERING_DISABLED) {
                var franchisor = (response.data.body.hasOwnProperty("franchisor")) ? new FranchisorModel(response.data.body.franchisor) : null;
                var errObj = { err: true, msg: ERROR_MSG.APP.ONLINE_ORDERING_DISABLED, franchisor: franchisor };
                callback({}, errObj);
            }
            else {
                var loadResponse = Object.assign({ baseURL: baseURL }, response);
                populateStores(loadResponse, callback);
            }
        })
            .catch(function (err) {
            EventBus.$emit('display-network-failure', null);
        });
    },
    customerBase: function () {
        return localStorageAdapter.getCustomerBase();
    }
};
export default allService;



//////////////////
// WEBPACK FOOTER
// ./src/services/all.service.ts
// module id = null
// module chunks = 